import PropTypes from 'prop-types';
import { Grid, Typography, Avatar, IconButton, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const StatCard = ({ icon, iconColor, bgColor, color, value, label, change, changeColor, isFilled, sx }) => {
  return (
    <Box
      sx={{
        backgroundColor: isFilled ? bgColor : '#fff',
        border: `2px solid ${isFilled ? '#6B298D' : 'transparent'}`,
        color: color,
        borderRadius: 3,
        boxShadow: 'none',
        p: 2,
        height: '100%',
        ...sx
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Avatar sx={{ bgcolor: iconColor }}>
            <IconButton sx={{ color: '#fff' }}>{icon}</IconButton>
          </Avatar>
        </Grid>
        <Grid item xs>
          <Typography variant="h4" sx={{ color: { color } }}>
            {value}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 500, color: { color } }}>
            {label}
          </Typography>
          <Typography variant="caption" sx={{ color: isFilled ? '#B2EBF2' : changeColor }}>
            <TrendingUpIcon fontSize="inherit" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
            {change}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

StatCard.propTypes = {
  icon: PropTypes.node,
  iconColor: PropTypes.string,
  bgColor: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  change: PropTypes.string,
  changeColor: PropTypes.string,
  isFilled: PropTypes.bool,
  sx: PropTypes.object
};

export default StatCard;
